import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';

import { selectLogin } from '@/store/login/selectors';

import { Button, Spin } from 'antd';

import LoginWrapper from '../LoginWrapper';

import css from './Login.module.scss';

const AuthSSOLogin = () => {
  const { t } = useTranslation('authorization');

  // const { imageBackgroundLogin, isLoadingImageLogo, imageLogo } = useOutletContext();
  const loginSelect = useSelector(selectLogin);

  return (
    <LoginWrapper type='auth'>
      {loginSelect.error && <span className={css['LoginPage-form-item-error']}>{loginSelect.error}</span>}
      <div className={css['LoginPage-footer']}>
        <Button
          size='large'
          type='primary'
          data-qa='loginBtn'
          onClick={() => window.location.replace('https://lk.severstal.com')}
          className={css['LoginPage-footer-btn']}
        >
          {t('enter')}
        </Button>
      </div>
    </LoginWrapper>
  );
};

export default AuthSSOLogin;
